/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Beta_Badge_TooltipInputs */



/**
* | output |
* | --- |
* | "Beta feature — still being finished, so behaviour may change." |
*
* @param {Beta_Badge_TooltipInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const beta_badge_tooltip = /** @type {((inputs?: Beta_Badge_TooltipInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Beta_Badge_TooltipInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Beta-Funktion — noch in Arbeit, das Verhalten kann sich ändern.")
	return /** @type {LocalizedString} */ ("Beta feature — still being finished, so behaviour may change.")
});